import { Component } from 'react';
import { connect } from 'react-redux';
import { navigateToOktaBroker } from 'services/auth/duck';

class ForceSSOLoginContainer extends Component {
    componentDidMount() {
        this.props.navigateToOktaBroker();
    }

    render() {
        return null;
    }
}

export default connect(null, { navigateToOktaBroker })(ForceSSOLoginContainer);



// WEBPACK FOOTER //
// ./src/containers/ForceSSOLoginContainer.js